import { Button } from '@/isomorphic/components/typography/button/button';
import { StepCommonProps } from '../types';
import { useEffect } from 'react';
import { useLogout } from '@/hooks/use-logout';
import clsx from 'clsx';
import { useBrandedColors } from '../hooks/use-branded-colors';
import { Icon } from './icon';

type RejectedApplicationProps = StepCommonProps & {
    onFinish: () => void;
};

export const RejectedApplication = ({ getLabel, onFinish, brandColor }: RejectedApplicationProps) => {
    const { useBrandedColorsBool, brandedLighter, getStyle } = useBrandedColors({ brandColor });
    const { logout } = useLogout();

    useEffect(() => {
        return () => {
            logout();
        };
    }, []);

    return (
        <div className="r-relative r-mx-auto r-mb-8 r-max-w-2xl r-space-y-4">
            <div
                className={clsx('r-space-y-8 r-rounded-xl r-border-2 r-bg-white r-p-6', useBrandedColorsBool ? '' : 'r-border-primary-200')}
                style={useBrandedColorsBool ? { borderColor: brandColor } : {}}
            >
                <div className="r-flex r-flex-col r-items-center r-space-y-4 r-text-center">
                    <div className="r-bg-soft-primary-100 r-mb-4 r-mt-2 r-flex r-items-center r-justify-center r-rounded-full">
                        <div className="r-w-16">
                            <Icon type="applicationLetter" colors={useBrandedColorsBool ? { bgColor: brandedLighter, pathColor: brandColor } : {}} />
                        </div>
                    </div>
                    <h2 className={clsx('r-text-3xl r-font-semibold', useBrandedColorsBool ? 'r-text-black' : 'r-text-primary-500')}>
                        {getLabel('rejectedTitle')}
                    </h2>
                    <p className="r-text-lg">{getLabel('rejectedDescription')}</p>

                    <div className="r-mx-auto r-max-w-xs r-space-y-2 r-text-center r-text-sm">
                        <div
                            className={clsx('styled-link r-text-md', useBrandedColorsBool ? 'brand-styles' : '')}
                            dangerouslySetInnerHTML={{ __html: getLabel('contactUsInformation') }}
                            style={useBrandedColorsBool ? getStyle() : {}}
                        />
                    </div>
                </div>

                <div className="r-mx-auto r-flex r-max-w-xs r-flex-col r-gap-4">
                    <Button
                        fullWidth
                        to={'/'}
                        onClick={onFinish}
                        className={clsx('r-text-white', useBrandedColorsBool ? '' : 'r-bg-primary-500')}
                        brandColor={brandColor}
                    >
                        {getLabel('landingPageButton')}
                    </Button>
                </div>
            </div>
        </div>
    );
};
